import * as React from 'react'

function SvgPl(props) {
	return (
		<svg viewBox="0 0 16 10" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h16v10H0z" />
			<path fill="#dc143c" d="M0 5h16v5H0z" />
		</svg>
	)
}

export default SvgPl
